import { render, staticRenderFns } from "./visuals.vue?vue&type=template&id=6481aff1&"
import script from "./visuals.vue?vue&type=script&lang=js&"
export * from "./visuals.vue?vue&type=script&lang=js&"
import style0 from "./visuals.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../rubis-bi/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports